import { createSelector } from '@ngrx/store';

import { getSelectedOrderType } from '../../../onlineOrder/selectors/getSelectedOrderType';
import { getOrderTypes } from '../getOrderTypes';

export const isSpecialInstructionForOrderEnabled = createSelector(
    getOrderTypes,
    getSelectedOrderType,
    (orderTypes: OLO.State.OrderTypes, selectedOrderType: APICommon.OrderTypeExtended) => {
        if (!orderTypes || !selectedOrderType) return false;

        const currentOrderType = orderTypes?.data.find((obj) => obj.Id === selectedOrderType.Id);

        return currentOrderType?.IsExtraInstructionsForOrdersEnabled;
    },
);
